import React from 'react';
import { useTranslation } from 'react-i18next';
import { CandidatesFilter } from './types';
import ClearFilters from './ClearFilters';
import SingleFilter from '../../../../../../components/SelectFilters/SingleFilter';
import { FlairMultiSelectDropdown } from '../../../../../../atomic/molecules/FlairDropdown/FlairMultiSelectDropdown/FlairMultiSelectDropdown';
import { PickListEntry } from '../../../../__generated__/graphql';

type Props = {
  filterData: CandidatesFilter;
  handleFilterChange: (filter: CandidatesFilter) => void;
  stageOptions: PickListEntry[];
  sourceOptions: PickListEntry[];
};

const FilterItem: React.FC<
  React.PropsWithChildren<{
    className?: string;
    children: React.ReactNode;
  }>
> = ({ className = '', children }) => {
  return <div className={`me-3 ${className}`}>{children}</div>;
};

const CandidatesListFilter: React.FC<React.PropsWithChildren<Props>> = ({
  filterData,
  handleFilterChange,
  stageOptions,
  sourceOptions,
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-none d-md-flex align-items-center">
      <span className="me-3 text-nowrap">
        {t('employeePage.teamCalendar.filterBy')}
      </span>
      <FilterItem>
        <FlairMultiSelectDropdown
          options={stageOptions}
          selectedOptions={filterData.stages ?? []}
          onChange={(selectedOptions) =>
            handleFilterChange({
              ...filterData,
              stages: selectedOptions.map((o) => o.value),
            })
          }
          placeholder={t(
            'recruitment.jobCandidatesPage.table.filters.funnelStage',
          )}
          isSearchable={true}
        />
      </FilterItem>
      <FilterItem>
        <SingleFilter
          placeholder={t(
            'recruitment.jobCandidatesPage.table.filters.applicationSource',
          )}
          isSearchable={true}
          options={sourceOptions}
          value={filterData.source}
          onChange={(value) =>
            handleFilterChange({ ...filterData, source: value })
          }
        />
      </FilterItem>

      <FilterItem>
        <ClearFilters />
      </FilterItem>
    </div>
  );
};

export default CandidatesListFilter;
